<template>
  <div>
    <c-box
      :title="'Динамика позиций в поисковых системах по региону продвижения ' + selectedRegion"
      shadow
      header-divider
      :loading="loading"
    >
      <template v-slot:header-right>
        <form class="form-inline">
          <sengine-select
            v-model="sengine"
            small
            margin-bottom="0"
          />
        </form>
      </template>

      <table
        v-if="!loading && table.rows.length"
        class="table"
      >
        <thead>
          <tr>
            <th>Выведено</th>
            <th
              v-for="(column, index) in table.columns"
              :key="index"
              v-text="column"
            />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in table.rows"
            :key="index"
          >
            <td v-text="item.label" />
            <th
              v-for="(value, columnIndex) in item.values"
              :key="columnIndex"
              :class="{'text-success': value > 0}"
              v-text="formatPercentage(value)"
            />
          </tr>
        </tbody>
      </table>
      <no-data v-if="!loading && !table.rows.length" />
    </c-box>

    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import SengineSelect from '../SengineSelect'
import moment from 'moment'
import { capitalizeFirstLetter, conclusion1CToHtml } from '../../../../../../../resources/js/helper'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import { mapState } from 'vuex'

export default {
  name: 'RegionDynamics',
  components: { NoData, SengineSelect, CBox },
  mixins: [sengine],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    },
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      sengine: this.$getConst('SENGINE_YANDEX')
    }
  },
  computed: {
    items () {
      if (this.selectedRegion && Array.isArray(this.data)) {
        const regionData = this.data.find(value => value.РегионПродвижения === this.selectedRegion)

        if (regionData && Array.isArray(regionData.МассивДанныхПоПС)) {
          const engineData = regionData.МассивДанныхПоПС
            .find(value => value.ПоисковаяСистема === this.getSengineName1C(this.sengine))

          if (engineData && Array.isArray(engineData.ТаблицаДинамики)) {
            return engineData.ТаблицаДинамики
          }
        }
      }

      return []
    },
    table () {
      const topKeys = [...new Set(this.items.flatMap(item => Object.keys(item)
        .filter(key => /^ТОП\d+_Процент$/.test(key))))]
        .sort((a, b) => Number(a.match(/\d+/)[0]) - Number(b.match(/\d+/)[0]))

      if (topKeys.length) {
        const periods = this.items
          .filter(item => moment(item.Выведено, moment.ISO_8601, true).isValid())
          .slice()
          .sort((a, b) => moment(a.Выведено).valueOf() - moment(b.Выведено).valueOf())

        return {
          columns: periods.map(item => moment(item.Выведено).format('DD.MM.YYYY')),
          rows: periods.length ? topKeys.map(key => ({
            label: 'в ТОП ' + Number(key.match(/\d+/)[0]),
            values: periods.map(item => item[key])
          })) : []
        }
      }

      const fields = ['Старт_ПроцентПозиций', 'Прошлый_ПроцентПозиций', 'Текущий_ПроцентПозиций']

      return {
        columns: [
          'На дату старта проекта',
          capitalizeFirstLetter(moment(this.from).format('MMMM YYYY')),
          capitalizeFirstLetter(moment(this.to).format('MMMM YYYY'))
        ],
        rows: this.items.filter(item => fields.some(field => field in item)).map(item => ({
          label: item.Выведено,
          values: fields.map(field => item[field])
        }))
      }
    },
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    },
    ...mapState({
      selectedRegion: state => state.seo.client.projects.selectedRegion
    })
  },
  methods: {
    formatPercentage (value) {
      return (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) && Number.isFinite(Number(value))
        ? value + '%'
        : '—'
    }
  }
}
</script>
